var $54b47fc030b7b21e$exports = {};
if (window.location.hash) history.replaceState(null, "", window.location.pathname);
window.scrollTo({
    top: 0,
    behavior: "instant"
});
window.addEventListener("pageshow", (e)=>{
    if (e.persisted) {
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
        history.replaceState(null, "", window.location.pathname);
    }
});
const $54b47fc030b7b21e$var$revealItems = [
    ...document.querySelectorAll("header, .montain, .hero, .menu, .projections, .communication, footer")
];
$54b47fc030b7b21e$var$revealItems.forEach((el)=>{
    el.style.opacity = "0";
});
$54b47fc030b7b21e$var$revealItems.forEach((el, i)=>{
    setTimeout(()=>{
        el.style.opacity = "";
        el.classList.add("page-reveal");
    }, i * 120);
});
document.querySelectorAll('a[href^="#"]').forEach((link)=>{
    link.addEventListener("click", (e)=>{
        const targetId = link.getAttribute("href").slice(1);
        const target = document.getElementById(targetId);
        if (!target) return;
        e.preventDefault();
        const headerHeight = document.querySelector("header")?.offsetHeight ?? 0;
        const targetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight;
        window.scrollTo({
            top: targetTop,
            behavior: "smooth"
        });
        history.pushState(null, "", `#${targetId}`);
    });
});
const $54b47fc030b7b21e$var$newsletterForm = document.querySelector(".com-newsletter-sub");
const $54b47fc030b7b21e$var$newsletterButton = document.querySelector(".com-newsletter-sub-button");
const $54b47fc030b7b21e$var$newsletterInput = document.querySelector(".com-newsletter-sub-email");
const $54b47fc030b7b21e$var$buttonText = document.querySelector(".com-newsletter-sub-button-text");
if ($54b47fc030b7b21e$var$newsletterForm) $54b47fc030b7b21e$var$newsletterForm.addEventListener("submit", async (e)=>{
    e.preventDefault();
    const email = $54b47fc030b7b21e$var$newsletterInput?.value?.trim();
    if (!email) return;
    if ($54b47fc030b7b21e$var$buttonText) $54b47fc030b7b21e$var$buttonText.textContent = "\u2026";
    if ($54b47fc030b7b21e$var$newsletterButton) $54b47fc030b7b21e$var$newsletterButton.disabled = true;
    try {
        await new Promise((r)=>setTimeout(r, 600)); // simulation
        if ($54b47fc030b7b21e$var$buttonText) $54b47fc030b7b21e$var$buttonText.textContent = "\u2713 Inscrit\xb7e";
        if ($54b47fc030b7b21e$var$newsletterInput) {
            $54b47fc030b7b21e$var$newsletterInput.value = "";
            $54b47fc030b7b21e$var$newsletterInput.disabled = true;
        }
    } catch  {
        if ($54b47fc030b7b21e$var$buttonText) $54b47fc030b7b21e$var$buttonText.textContent = "Erreur";
        setTimeout(()=>{
            if ($54b47fc030b7b21e$var$buttonText) $54b47fc030b7b21e$var$buttonText.textContent = "Inscription";
            if ($54b47fc030b7b21e$var$newsletterButton) $54b47fc030b7b21e$var$newsletterButton.disabled = false;
        }, 2000);
    }
});


//# sourceMappingURL=index.ea907947.js.map
